<script setup lang="ts">import { ref as _ref } from 'vue';

import { type Category } from '@consumer/logic/v2/header'
import { Swiper, SwiperSlide } from 'swiper/vue'
import CategoryBarButton from './CategoryBar/Button.vue'
import CategoryBarMobileModal from './CategoryBar/MobileModal.vue'

import 'swiper/css'

const props = defineProps<{
  categories: Category[]
  iconLayout?: 'row' | 'col'
  dataQAString?: string | undefined
}>()
const { categories } = toRefs(props)

let mobileModalCategory = _ref<Category | null>(null)
let mobileModalOpen = _ref(false)

const openMobileModal = (category: Category) => {
  if (category.links) {
    mobileModalCategory.value = category
    mobileModalOpen.value = true
  }
}
</script>

<template>
  <div class="w-full flex justify-center relative">
    <Swiper
      :slidesPerView="'auto'"
      :spaceBetween="12"
    >
      <SwiperSlide
        v-for="category, key in categories"
        :key="key"
        class="header-v2-category-swiper-slide"
        :class="{
          'place-content-center':iconLayout==='row',
        }"
      >
        <CategoryBarButton
          :category="category"
          :iconLayout="iconLayout"
          :dataQAString="props.dataQAString"
          class="!w-auto p-2"
          gaTrackingString="open-nav-categories"
          @click="openMobileModal(category)"
        />
      </SwiperSlide>
    </Swiper>

    <CategoryBarMobileModal v-model:category="mobileModalCategory" v-model:open="mobileModalOpen"/>
  </div>
</template>

<style lang="scss" scoped>
.header-v2-category-swiper-slide {
  width: auto;
}
</style>
